export const isRangeValid = (utils, range) => {
  return utils.isValid(range[0]) && utils.isValid(range[1]) && !utils.isBefore(range[1], range[0]);
};
export const isWithinRange = (utils, day, range) => {
  return isRangeValid(utils, range) && utils.isWithinRange(day, range);
};
export const isStartOfRange = (utils, day, range) => {
  return isRangeValid(utils, range) && utils.isSameDay(day, range[0]);
};
export const isEndOfRange = (utils, day, range) => {
  return isRangeValid(utils, range) && utils.isSameDay(day, range[1]);
};
export const formatRange = (utils, range, formatKey) => {
  if (!isRangeValid(utils, range)) {
    return null;
  }
  return `${utils.format(range[0], formatKey)} - ${utils.format(range[1], formatKey)}`;
};